//#region src/starbucks_concept.ts
var StarbucksConcept = /* @__PURE__ */ function(StarbucksConcept) {
	StarbucksConcept["Airport"] = "airport";
	StarbucksConcept["Grocery"] = "grocery";
	StarbucksConcept["College"] = "college";
	return StarbucksConcept;
}(StarbucksConcept || {});
//#endregion
export { StarbucksConcept };

//# sourceMappingURL=starbucks_concept.js.map